import { Component, Input } from '@angular/core';
import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';

@Component({
  selector: 'app-form-tooltip',
  imports: [TooltipComponent],
  templateUrl: './form-tooltip.component.html',
})
export class FormTooltipComponent {
  @Input() public text: string;
}
